import { Fraction } from "fractional";
import icons from "../../img/icons.svg";
import View from "./View";
import { Recipe } from "../model";
import { Callback } from "../config";

export class RecipeView extends View<Recipe> {
  protected parentElement: Element = document.querySelector(".recipe");
  protected errorMessage: string =
    "We could not find that recipe. Please try another one!";
  protected message: string = "";

  addHandlerRender(handler: Callback): void {
    window.addEventListener("hashchange", handler);
    window.addEventListener("load", handler);

    // ['hashchange', 'load'].forEach((event: string) =>
    //   window.addEventListener(event, handler)
    // );
  }

  addHandlerAddBookmark(handler: Callback): void {
    this.parentElement.addEventListener("click", (e: Event) => {
      const target = e.target as Element;
      const btn = target.closest(".btn--bookmark") as HTMLButtonElement;
      if (!btn) return;
      handler();
    });
  }

  addHandlerUpdateServings(handler: Function): void {
    this.parentElement.addEventListener("click", (e: Event) => {
      const target = e.target as Element;
      const btn = target.closest(".btn--update-servings") as HTMLButtonElement;
      if (!btn) return;

      const updateTo = +btn.dataset.updateTo;
      if (updateTo > 0) handler(updateTo);
    });
  }

  protected generateMarkup(): string {
    return `
    <figure class="recipe__fig">
    <img src="${this.data.image}" alt="${
      this.data.title
    }" class="recipe__img" />
    <h1 class="recipe__title">
      <span>${this.data.title}</span>
    </h1>
  </figure>

  <div class="recipe__details">
    <div class="recipe__info">
      <svg class="recipe__info-icon">
        <use href="${icons}#icon-clock"></use>
      </svg>
      <span class="recipe__info-data recipe__info-data--minutes">${
        this.data.cookingTime
      }</span>
      <span class="recipe__info-text">minutes</span>
    </div>
    <div class="recipe__info">
      <svg class="recipe__info-icon">
        <use href="${icons}#icon-users"></use>
      </svg>
      <span class="recipe__info-data recipe__info-data--people">${
        this.data.servings
      }</span>
      <span class="recipe__info-text">servings</span>

      <div class="recipe__info-buttons">
        <button class="btn--tiny btn--update-servings" data-update-to="${
          this.data.servings - 1
        }">
          <svg>
            <use href="${icons}#icon-minus-circle"></use>
          </svg>
        </button>
        <button class="btn--tiny btn--update-servings" data-update-to="${
          this.data.servings + 1
        }">
          <svg>
            <use href="${icons}#icon-plus-circle"></use>
          </svg>
        </button>
      </div>
    </div>

    <div class="recipe__user-generated ${this.data.key ? "" : "hidden"}">
      <svg>
        <use href="${icons}#icon-user"></use>
      </svg>
    </div>
    <button class="btn--round btn--bookmark">
      <svg class="">
        <use href="${icons}#icon-bookmark${
      this.data.bookmarked ? "-fill" : ""
    }"></use>
      </svg>
    </button>
  </div>

  <div class="recipe__ingredients">
    <h2 class="heading--2">Recipe ingredients</h2>
    <ul class="recipe__ingredient-list">
    ${this.data.ingredients.map(this.generateMarkupIngredient).join("")}
    </ul>
  </div>

  <div class="recipe__directions">
    <h2 class="heading--2">How to cook it</h2>
    <p class="recipe__directions-text">
      This recipe was carefully designed and tested by
      <span class="recipe__publisher">${
        this.data.publisher
      }</span>. Please check out
      directions at their website.
    </p>
    <a
      class="btn--small recipe__btn"
      href="${this.data.sourceUrl}"
      target="_blank"
    >
      <span>Directions</span>
      <svg class="search__icon">
        <use href="${icons}#icon-arrow-right"></use>
      </svg>
    </a>
  </div>
`;
  }

  protected generateMarkupIngredient(ing: {
    [key: string]: string | number;
  }): string {
    return `
        <li class="recipe__ingredient">
          <svg class="recipe__icon">
            <use href="${icons}#icon-check"></use>
          </svg>
          <div class="recipe__quantity">${
            ing.quantity ? new Fraction(ing.quantity).toString() : ""
          }</div>
          <div class="recipe__description">
            <span class="recipe__unit">${ing.unit}</span>
            ${ing.description}
          </div>
        </li>
      `;
  }
}
